module.exports = __webpack_public_path__ + "img/icon6.9f2b8275.png";